
import axios from "@/services/axios";
import { getLogoPath } from "@/locales/i18n";
import { defineComponent, reactive, inject, computed } from "vue";
import { AxiosResponse } from "axios";
import { useI18n } from "vue-i18n";
import useVuelidate from "@vuelidate/core";
import UserRepositoryAPI from "@/modules/user/user-repository-api";

interface UserRegister {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  researchOrganizationId: string;
  researcherStatusId: string;
  createdDate: string;
  username: string;
  password: string;
  passwordRepeat: string;
  GDPRConsent: GDPR;
  External: boolean;
  researchInstitutionMSTID: string;
}

type GDPR = "APPROVED" | "DECLINED";

export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const { t } = useI18n();
    const toast: any = inject("toast");
    const keycloak = inject("keycloak") as Keycloak.KeycloakInstance;
    const state = reactive({
      gdprConsentEnabled: false,
      consentEnabled: false,
      user: {
        GDPRConsent: "DECLINED",
        External: true,
      } as UserRegister,
      termsOfUse: false,
      submitted: false,

      researchInstitutions: [] as Array<any>,
      researchInstitutionId: "",
    });

    const requiredTrue = (value: boolean) => state.gdprConsentEnabled;

    const rules = computed(() => ({
      gdprConsentEnabled: {
        requiredTrue,
      },
      consentEnabled: {
        requiredTrue,
      },
    }));
    const v$ = useVuelidate(rules, state);

    const { getUser } = UserRepositoryAPI();

    const close = () => {
      context.emit("close");
    };

    const notificationDisplay = (
      severity: string,
      summary: string,
      detail?: string
    ): void => {
      toast.add({
        severity: severity,
        summary: summary,
        detail: detail,
        life: 3000,
      });
    };

    const onClickRegister = (): void => {
      v$.value.$validate();
      if (v$.value.$error) {
        state.submitted = true;
        return;
      }

      if (state.gdprConsentEnabled) {
        state.user.GDPRConsent = "APPROVED";

        axios
          .put(`/api/v1/User/${getUser.value.id}/consenttogdpr`, state.user)
          .then((response: any) => {
            if (response.status === 204) {
              notificationDisplay("success", "GDPR soglasje uspešno podano");
              close();
              return;
            }
            notificationDisplay("warn", "GDPR soglasje ni podano");
          })
          .catch((err: AxiosResponse) => {
            console.error(err);
            notificationDisplay("error", "Napaka zahteve");
          });
      }
    };

    const onClickLogin = () => {
      keycloak.login({ redirectUri: window.origin });
    };

    return {
      t,
      state,
      onClickRegister,
      v$,
      onClickLogin,
      getLogoByLocale: computed(() => getLogoPath()),
    };
  },
});
